var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsergroupUnSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 25 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_1581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6906 9.525C11.3208 9.525 13.4531 7.39271 13.4531 4.7625C13.4531 2.13229 11.3208 0 8.6906 0C6.06039 0 3.9281 2.13229 3.9281 4.7625V4.76354C3.9307 7.39271 6.06143 9.52292 8.6906 9.525ZM8.6906 1.66771C10.4005 1.66771 11.7864 3.05365 11.7864 4.76354C11.7864 6.47344 10.4005 7.85938 8.6906 7.85938C6.98071 7.85938 5.59477 6.47344 5.59477 4.76354C5.59633 3.05417 6.98123 1.66927 8.6906 1.66771Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.94167C20.7062 9.94167 22.2916 8.35625 22.2916 6.4C22.2916 4.44375 20.7062 2.85834 18.75 2.85834C16.7937 2.85834 15.2083 4.44375 15.2083 6.4C15.2104 8.35521 16.7948 9.93959 18.75 9.94167ZM18.75 4.525C19.7854 4.525 20.625 5.36459 20.625 6.4C20.625 7.43542 19.7854 8.275 18.75 8.275C17.7146 8.275 16.875 7.43542 16.875 6.4C16.876 5.36511 17.7151 4.52605 18.75 4.525Z",
    fill: "#484888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.9167C17.051 10.9219 15.4271 11.6167 14.25 12.8417C10.5578 9.77291 5.07656 10.2781 2.00781 13.9708C0.710937 15.5312 0.000520833 17.4958 0 19.525C0 19.9854 0.372917 20.3583 0.833333 20.3583H16.55C17.0104 20.3583 17.3833 19.9854 17.3833 19.525C17.3818 19.0135 17.3354 18.5031 17.2443 18H24.1667C24.6271 18 25 17.6271 25 17.1667C24.9964 13.7167 22.2 10.9203 18.75 10.9167ZM1.71562 18.6917C2.16771 14.8411 5.65573 12.0859 9.50625 12.538C12.2604 12.8614 14.5667 14.776 15.3906 17.4239C15.524 17.8364 15.6161 18.2609 15.6667 18.6917H1.71562ZM16.7594 16.3333C16.4333 15.5016 15.9802 14.725 15.4167 14.0318C17.1453 12.187 20.0417 12.0927 21.887 13.8208C22.6016 14.4901 23.0823 15.3708 23.2594 16.3333H16.7594Z",
    fill: "#484888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_1581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 20.3583,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsergroupUnSelected);
export default __webpack_public_path__ + "static/media/usergroupUnSelected.38a31f29e6e94e57e90a20a06f94f36f.svg";
export { ForwardRef as ReactComponent };